import React from 'react'

const Services = () => {
  return (
    <div>
      <div>
        <div className=" bg-[#EDF5F8] h-auto">
          <div className="flex flex-col items-center justify-center pt-20">
            <div className="px-3 py-1 border-b-8 border-l-8 border-[#5f3afc] w-44 half-top-border ">
              <h2 className="text-sm md:text-xl pt-1 text-[#0B2B3c] font-bold">
                OUR SERVICES
              </h2>
            </div>
            <h1 className="text-4xl font-black pb-10 text-[#0B2B3C] text-center">
              Our Main Focus
            </h1>
          </div>
          <div className="w-full md:flex md:gap-3 md:px-[2rem]">
            <div className="md:w-1/3 p-4 md:pb-20">
              <div className="bg-white text-center p-8 rounded hover-card transform transition-transform duration-300 hover:-translate-y-2">
                <img
                  src="https://preetheme.com/html/bhouse/assets/img/1.png"
                  alt="contactus"
                  className="mx-auto mb-4 w-14 md:w-1/3"
                />
                <p className="text-xl font-bold md:mb-6 mb-4 text-[#5f3afc]">
                  Buy A Home
                </p>
                <p className="text-sm md:mb-6 mb-4">
                  Arose mr rapid in so vexed words. Gay welcome led add to
                  lasting chiefly say to looking for better.
                </p>
                <div className="border-line-container">
                  <p className="text-light">Get Now &rarr;</p>
                </div>
              </div>
            </div>

            <div className="md:w-1/3 p-4 md:pb-20">
              <div className="bg-white text-center p-8 rounded hover-card transform transition-transform duration-300 hover:-translate-y-2">
                <img
                  src="https://preetheme.com/html/bhouse/assets/img/1.png"
                  alt="contactus"
                  className="mx-auto mb-4 w-14 md:w-1/3"
                />
                <p className="text-xl font-bold md:mb-6 mb-4 text-[#5f3afc]">
                  Buy A Home
                </p>
                <p className="text-sm md:mb-6 mb-4">
                  Arose mr rapid in so vexed words. Gay welcome led add to
                  lasting chiefly say to looking for better.
                </p>
                <div className="border-line-container">
                  <p className="text-light">Get Now &rarr;</p>
                </div>
              </div>
            </div>
            <div className="md:w-1/3 p-4 md:pb-20">
              <div className="bg-white text-center p-8 rounded hover-card transform transition-transform duration-300 hover:-translate-y-2">
                <img
                  src="https://preetheme.com/html/bhouse/assets/img/1.png"
                  alt="contactus"
                  className="mx-auto mb-4 w-14 md:w-1/3"
                />
                <p className="text-xl font-bold md:mb-6 mb-4 text-[#5f3afc]">
                  Buy A Home
                </p>
                <p className="text-sm md:mb-6 mb-4">
                  Arose mr rapid in so vexed words. Gay welcome led add to
                  lasting chiefly say to looking for better.
                </p>
                <div className="border-line-container">
                  <p className="text-light">Get Now &rarr;</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Services
